import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { PeriodoDet } from '../models/periodoDet';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/PeriodoDet';

@Injectable({
  providedIn: 'root'
})
export class PeriodoDetService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getOne(code): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index?id=' + code })
  }

  getPeriodoCab(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetByPeriodoCab?periodoid=' + code })
  }

  getProximo(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetProximo?id=' + code })
  }

  getAnterior(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetAnterior?id=' + code })
  }

  save(periodoDet: PeriodoDet)
  {
    return this._http.post({ url: baseUrl + '/Save', body: periodoDet });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }
}

